import React from 'react';
import { CardTitle, CardSubhead } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import styled from 'styled-components';

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const MotoristaHeader = ({ totalRegistros, onNovo }) => (
  <HeaderWrap>
    <div>
      <CardTitle>Motoristas</CardTitle>
      <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
    </div>
    <ButtonWithLoading variant="primary" onClick={onNovo} loading={false}>
      Novo Motorista
    </ButtonWithLoading>
  </HeaderWrap>
);

export default MotoristaHeader;
